module.exports = __webpack_public_path__ + "img/Weapon_252.c2fb3f7e.png";